module.exports = __webpack_public_path__ + "img/upcoming-tournament-image.79210356.jpg";